import { TableWrapper, type TableWrapperProps } from "../../../common/components/Table.tsx";
import * as commonColumns from "../../../common/columns.tsx";
import type { PaginatedturbineResultsSideloadList } from "../../generated-axios-client/index.ts";
import type { AnyObject } from "antd/es/_util/type";
import type { TurbineViewRenderProps } from "./TurbineViewRender.tsx";
import { Card } from "../../../common/components/Card.tsx";
import { componentTableRender } from "./componentTableRender.tsx";

const getColumns: TableWrapperProps<
  PaginatedturbineResultsSideloadList,
  AnyObject
>["getColumns"] = (intl) => [
  commonColumns.simpleColumn("component_type", "component_table_column_type", intl),
  commonColumns.simpleColumn("serial_number", "component_table_column_serial_number", intl),
  commonColumns.simpleColumn("model", "component_table_column_model", intl),
  commonColumns.simpleColumn("set_number", "component_table_column_set_number", intl),
  commonColumns.simpleColumn("created_at", "component_table_column_created_at", intl),
  commonColumns.simpleColumn("updated_at", "component_table_column_updated_at", intl),
  commonColumns.simpleColumn("actions", "table_column_actions", intl),
];

export const ComponentsInfo = (props: TurbineViewRenderProps) => {
  const { intl, turbineData, modalApi } = props;

  return (
    <Card title={intl.formatMessage({ id: "turbine_components" })}>
      <TableWrapper
        intl={intl}
        getColumns={getColumns}
        getRows={componentTableRender}
        modalApi={modalApi}
        data={turbineData}
        size="small"
      />
    </Card>
  );
};
